var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.text[0])?_c('span',[_vm._v(_vm._s(_vm.text[0]))]):_vm._e(),_vm._v(" "),(_vm.text[1])?_c('span',[_vm._v(_vm._s(_vm.text[1]))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }